
  import React from "react"
  import Component from "/home/circleci/repo/packages/web/src/layouts/index.js"
  import data from "/home/circleci/repo/packages/web/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js